import React from "react";
import { Timer, Clock, Loader2 } from "lucide-react";
import { DailyStatsFicha } from "../types";

interface StatsCardProps {
  dailyStats: DailyStatsFicha;
}

export const StatsCard: React.FC<StatsCardProps> = ({ dailyStats }) => {
  const unidades = dailyStats.producaoPorUnd ?? [];

  return (
    <div className="mt-3 shrink-0 sm:mt-4">
      <div className="rounded-lg border border-white/20 bg-white/10 p-3 backdrop-blur-sm sm:rounded-xl sm:p-4 lg:p-5">
        <div className="grid grid-cols-2 gap-3 text-center sm:grid-cols-4 sm:gap-6">
          <div className="col-span-2 sm:col-span-1">
            <div className="mb-1 flex flex-wrap items-center justify-center gap-1.5">
              {unidades.length > 0 ? (
                unidades.map((und) => (
                  <span
                    key={und.undNome}
                    className={`rounded-lg px-2.5 py-0.5 font-mono text-lg font-black tabular-nums sm:text-2xl lg:text-3xl ${
                      und.undNome.toLowerCase() === "kg"
                        ? "bg-orange-400/25 text-orange-300"
                        : "bg-white/15 text-white"
                    }`}
                  >
                    {und.totalFormatado}
                  </span>
                ))
              ) : (
                <span className="text-2xl font-black text-orange-300 sm:text-4xl">
                  {dailyStats.producaoKgFormatado || "0"}
                </span>
              )}
            </div>
            <p className="text-sm opacity-75 sm:text-base lg:text-lg">
              Produzido
            </p>
          </div>
          <div>
            <div className="mb-0.5 flex items-center justify-center space-x-1 sm:mb-1 sm:space-x-2">
              <Timer className="h-5 w-5 text-sky-400 sm:h-6 sm:w-6" />
              <span className="text-2xl font-black text-sky-300 sm:text-4xl">
                {dailyStats.itensEncerrados}
              </span>
            </div>
            <p className="text-sm opacity-75 sm:text-base lg:text-lg">
              Itens encerrados
            </p>
          </div>
          <div>
            <div className="mb-0.5 flex items-center justify-center space-x-1 sm:mb-1 sm:space-x-2">
              <Loader2
                className={`h-5 w-5 text-amber-400 sm:h-6 sm:w-6 ${dailyStats.emProducao > 0 ? "animate-spin" : ""}`}
              />
              <span className="text-2xl font-black text-amber-300 sm:text-4xl">
                {dailyStats.emProducao}
              </span>
            </div>
            <p className="text-sm opacity-75 sm:text-base lg:text-lg">
              Produzindo agora
            </p>
          </div>
          <div>
            <div className="mb-0.5 flex items-center justify-center space-x-1 sm:mb-1 sm:space-x-2">
              <Clock className="h-5 w-5 text-blue-400 sm:h-6 sm:w-6" />
              <span className="text-2xl font-black text-blue-300 sm:text-4xl">
                {dailyStats.itensEncerrados > 0
                  ? dailyStats.tempoMedioFormatado
                  : "—"}
              </span>
            </div>
            <p className="text-sm opacity-75 sm:text-base lg:text-lg">
              Tempo médio
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
